import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Smartphone, DollarSign, Camera } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: <Smartphone className="w-6 h-6 text-gold" data-id="element-278" />,
    title: 'Ventas por WhatsApp',
    desc: 'Usa la herramienta que ya conoces. Sin páginas web complicadas. Si sabes enviar un mensaje, sabes vender.'
  }, {
    icon: <Camera className="w-6 h-6 text-gold" data-id="element-279" />,
    title: 'Fotos con tu Celular',
    desc: 'Aprende a tomar fotos que enamoren usando el teléfono que tienes en la mano. Sin equipos caros.'
  }, {
    icon: <DollarSign className="w-6 h-6 text-gold" data-id="element-280" />,
    title: 'Precios Justos',
    desc: "Cómo ponerle precio a tu trabajo para que no te sientas 'explotada', sino valorada y bien pagada."
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-281" />,
    title: 'Grupos de Facebook',
    desc: 'Encuentra clientes en los grupos donde ya participas todos los días. Sin pagar publicidad.'
  }];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-282">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-blush/30 -skew-x-12 transform translate-x-20" data-id="element-283"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-284">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-285">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-286">
            <div className="section-divider-gold mx-0 mb-6" data-id="element-287"></div>
            <span className="text-gold font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-288">
              La Solución Definitiva
            </span>
            <h2 className="text-4xl md:text-6xl font-serif font-bold text-brown mb-8 leading-tight" data-id="element-289">
              El Método{' '}
              <span className="text-gold-gradient" data-id="element-290">"Hogar Dorado"</span>
            </h2>
            <p className="text-xl text-brown-light mb-10 leading-relaxed font-light" data-id="element-291">
              Este no es un curso de tecnología. Es una guía de libertad. He
              destilado solo lo que funciona para nosotras, eliminando todo el
              ruido técnico que te paraliza.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-292">
              {features.map((feature, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="flex items-start space-x-4" data-id="element-293">
                  <div className="flex-shrink-0 mt-1 bg-gold/10 p-2 rounded-lg" data-id="element-294">
                    {feature.icon}
                  </div>
                  <div data-id="element-295">
                    <h4 className="font-bold text-brown text-lg mb-1" data-id="element-296">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-brown-light leading-relaxed" data-id="element-297">
                      {feature.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-cream p-10 rounded-[2rem] border-2 border-gold/20 shadow-2xl relative" data-id="element-298">
            <div className="absolute -top-8 -right-8 bg-gold text-white w-32 h-32 rounded-full flex items-center justify-center font-bold text-center p-4 shadow-lg transform rotate-12 border-4 border-white" data-id="element-299">
              <span className="text-lg leading-tight" data-id="element-300">
                ¡Sin estrés técnico!
              </span>
            </div>

            <h3 className="text-3xl font-serif font-bold text-brown mb-8 text-center" data-id="element-301">
              Lo que lograrás:
            </h3>

            <ul className="space-y-5" data-id="element-302">
              {['Convertir tu hobby en un negocio real', 'Recibir pagos por Zelle con orgullo', 'Sentirte útil y productiva desde casa', 'Dejar de depender económicamente de otros', 'Ser un ejemplo de superación para tus nietos'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center bg-white p-5 rounded-xl shadow-sm border border-gold/5" data-id="element-303">
                  <CheckCircle2 className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-304" />
                  <span className="text-brown font-medium text-lg" data-id="element-305">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}